import { ENDPOINTS, getApiUrl, Requests } from "@/common";
import {
  ICreateUserReportPayload,
  IMyReportsResponse,
  IUserReport,
  UserReportStatus,
  UserReportType,
} from "@/common/types/user-report";

export const createUserReport = async (
  payload: ICreateUserReportPayload,
): Promise<IUserReport> => {
  const apiUrl = getApiUrl(ENDPOINTS.CREATE_USER_REPORT);
  const formData = new FormData();

  formData.append("type", payload.type);
  formData.append("title", payload.title);
  formData.append("description", payload.description);

  if (payload.pageUrl) {
    formData.append("pageUrl", payload.pageUrl);
  }

  if (payload.deviceInfo) {
    formData.append("deviceInfo", JSON.stringify(payload.deviceInfo));
  }

  if (payload.audioDuration) {
    formData.append("audioDuration", String(payload.audioDuration));
  }

  if (payload.images && payload.images.length > 0) {
    payload.images.forEach((file) => {
      formData.append("images", file);
    });
  }

  if (payload.audioBlob) {
    const audioFile = new File([payload.audioBlob], "report-voice.webm", {
      type: payload.audioBlob.type || "audio/webm",
    });
    formData.append("audio", audioFile);
  }

  return Requests.post(apiUrl, formData, true, false);
};

export const getMyUserReports = async (
  page = 1,
  limit = 20,
): Promise<IMyReportsResponse> => {
  const apiUrl = getApiUrl(ENDPOINTS.GET_MY_USER_REPORTS);
  return Requests.get(`${apiUrl}?page=${page}&limit=${limit}`);
};

export interface IQueryUserReportsParams {
  page?: number;
  limit?: number;
  status?: UserReportStatus;
  type?: UserReportType;
  search?: string;
}

export const getAllUserReports = async (
  params: IQueryUserReportsParams = {},
): Promise<{ data: IUserReport[]; total: number; page: number; limit: number }> => {
  const queryParts: string[] = [];
  if (params.page) queryParts.push(`page=${params.page}`);
  if (params.limit) queryParts.push(`limit=${params.limit}`);
  if (params.status) queryParts.push(`status=${params.status}`);
  if (params.type) queryParts.push(`type=${params.type}`);
  if (params.search) queryParts.push(`search=${encodeURIComponent(params.search)}`);

  const queryString = queryParts.length > 0 ? `?${queryParts.join("&")}` : "";
  const apiUrl = `${getApiUrl(ENDPOINTS.GET_USER_REPORTS)}${queryString}`;
  return Requests.get(apiUrl);
};

export const updateUserReportStatus = async (
  id: string,
  payload: { status: UserReportStatus; adminResponse?: string },
): Promise<IUserReport> => {
  const apiUrl = getApiUrl(ENDPOINTS.UPDATE_USER_REPORT_STATUS, { id }, true);
  return Requests.patch(apiUrl, payload);
};
